import {
	parent_matches,
	parse_from_text_html
} from '../../../../../webui/js/dom/element.js';
import {merge, NODE_ENTERING, NODE_UPDATE_ATTRIBUTES, update_attributes} from "../../../../../webui/js/dom/merge.js";
import {xhr_response_text} from '../../../../../webui/js/dom/form.js';

export function merge_xhr_result (xhr)
{
	const content_type = xhr.getResponseHeader('Content-Type')
	if (xhr.status >= 200 && xhr.status < 400)
	{
		// Success!
		const response = xhr_response_text(xhr)

		const new_document = parse_from_text_html(response)
		let new_node, cur_node

		const id_elements = document.querySelectorAll("[id]")
		const id_element_count = id_elements.length

		const ids = []

		const on_update_attributes = (new_node, cur_node) =>
		{
			if (cur_node === document.documentElement) {
				// do not update attributes of html because it contains ui-state (e.g. modal behaviour)
				return false
			}
			else if (cur_node.classList.contains('ui-modal-active')) {
				// do not update attributes of active modals because it contains ui-state (e.g. modal is active)
				return false
			}

			return true
		}

		const node = (n, operation, other) => {
			if (operation === NODE_ENTERING)
			{
				if (ids.indexOf(other.id) >= 0) {
					return false
				}

				if (n.dataset && n.dataset.merge === 'ignore' ||
				other.dataset && other.dataset.merge === 'ignore')
				{
					// do not enter
					return false
				}
			}
			else if (operation === NODE_UPDATE_ATTRIBUTES) {
				if (!on_update_attributes(n, other)) {
					return false
				}
			}

			return n
		}

		for (let i = id_element_count - 1; i >= 0; i--) {
			cur_node = id_elements[i]
			const id = cur_node.id
			let new_node = new_document.getElementById(id)
			if (new_node) {
				if (!parent_matches(new_node, "[data-merge=ignore]")) {
					if (merge({
						cur_node, new_node, node
					}))
					{
						ids.push(id)
					}
				}
			}
		}

		//alert(id_element_count)

		if (id_element_count === 0) {
			cur_node = document.body
			new_node = new_document.body
			merge({
				cur_node,
				new_node
			});
		}

		if (on_update_attributes(new_document.documentElement, document.documentElement)) {
			update_attributes(document.documentElement, new_document.documentElement)
		}

		return {
			new_document,
			id_element_count,
			ids
		};

	}
	else {
		// We reached our target server, but it returned an error
		alert("We reached our target server, but it returned an error")
	}

	return false;
}
